import React, { useState, useEffect, useRef, useContext } from 'react';
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';

//NEW
import { ConfirmPopup } from 'primereact/confirmpopup'; // To use <ConfirmPopup> tag
import { confirmPopup } from 'primereact/confirmpopup'; // To use confirmPopup method
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { GetSuppliers, AddSupplier, UpdateSupplier, DeleteSupplier } from 'services/supplier/supplier.service';
import AuthContext from  "../../context/AuthContext";

import { Table } from 'components/Table/Table';
import { NameColumn, TextColumn, LinkColumn } from 'components/Table/ColumnTemplates/CustomColumn';
import CreateModal from 'components/Modal/CreateModal';
import { SupplierValidationSchema } from 'utilities/ValidationSchema/Supplier/SupplierValidationSchema';
import duplicateNameChecker from 'utilities/duplicateNameChecker';

const Supplier = () => {
    const { supplierList, supplierListLoading } = useSelector((state) => state.supplierList);
    const { supplierAdd, supplierAddLoading } = useSelector((state) => state.supplierAdd);
    const { supplierUpdate, supplierUpdateLoading } = useSelector((state) => state.supplierUpdate);

    const [showForm, setShowForm] = useState(false); //* state for form modal
    const [updateData, setUpdateData] = useState(null); // * state for update data
    const [btnLoading, setBtnLoading] = useState(false); // * state for loading button
    const [autoCategoryFilteredValue, setAutoCategoryFilteredValue] = useState([]);
    const [autoUomFilteredValue, setAutoUomFilteredValue] = useState([]);
    const [duplicateNameExist, setDuplicateNameExist] = useState(false);

    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();
    const { user } = useContext(AuthContext);


    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        name: "",
        contact_name_one: "",
        contact_number_one: "",
        contact_name_two: "",
        contact_number_two: "",
        contact_email: "",
        address_one: "",
        address_two: "",
        website: "",
        remark: "",
    };

    const updateInitialValue = {
        ...updateData,
    };

    const formik = useFormik({
        initialValues: updateData ? updateInitialValue : createInitialValue, // * if state is update then updateData state value will show up
        validationSchema: SupplierValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            handelSubmit(values);
        },
        enableReinitialize: true,
    });

    const editSupplier = (supplier) => {
        setShowForm(true); // * set the form to true
        setUpdateData(supplier);
    };

    // delete 1
    const toast = useRef(null);

    const DeleteModal =  (event, id) => {

        confirmPopup({
            target: event.currentTarget,
            message: 'Do you want to delete this record?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: async () => {
                await dispatch(DeleteSupplier(id))
                await toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
                await dispatch(GetSuppliers());
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
    };

    // form submit handler
    const handelSubmit = async (data) => {

        if(updateData){
            await dispatch(UpdateSupplier(data)).then(() => {
                hideModal();
            });
            return
        }
        await dispatch(AddSupplier(data)).then(() => {
            hideModal();
            return
        });
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
        setShowForm(false); // * close the form
        setBtnLoading(false); // * loading button state to false
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(GetSuppliers());
    }, [supplierAdd, supplierUpdate]);


    // columns of the table with header name
    const tableColumns = [
        { field: "name", header: "Name", sortableBody: NameColumn },
        { field: "contact_name_one", header: "Contact Name One", sortableBody: TextColumn },
        { field: "contact_name_two", header: "Contact Name Two", sortableBody: TextColumn },
        { field: "contact_number_one", header: "Contact Number One", sortableBody: TextColumn },
        { field: "contact_number_two", header: "Contact Number Two", sortableBody: TextColumn },
        { field: "contact_email", header: "Email", sortableBody: TextColumn },
        { field: "address_one", header: "Address One", sortableBody: TextColumn },
        { field: "address_two", header: "Address Two", sortableBody: TextColumn },
        { field: "website", header: "Website", sortableBody: LinkColumn },
        { field: "remark", header: "Remark", sortableBody: TextColumn },
    ];


        // * input data array of object for the form / modal
        const inputData = [
            {
                id: "name",
                name: "name",
                type: "text",
                labelFor: "Name",
                label: "Enter a Name",
                required: true,
                className: "col-12 md:col-6",
                onBlur: (e) => duplicateNameChecker(e.target.value, supplierList, updateData, setDuplicateNameExist),
            },
            {
                id: "contact_email",
                name: "contact_email",
                value: "contact_email",
                type: "text",
                labelFor: "Email",
                label: "Email",
                required: false,
                messagePosition: 'bottom',
                className: "col-12 md:col-6",
            },
            {
                id: "contact_name_one",
                name: "contact_name_one",
                value: "contact_name_one",
                type: "text",
                labelFor: "Contact Name One",
                label: "Contact Name One",
                required: true,
                messagePosition: 'bottom',
                className: "col-12 md:col-6",
            },
            {
                id: "contact_number_one",
                name: "contact_number_one",
                value: "contact_number_one",
                type: "text",
                labelFor: "Contact Number One",
                label: "Contact Number One",
                required: true,
                messagePosition: 'bottom',
                className: "col-12 md:col-6",
            },
            {
                id: "contact_name_two",
                name: "contact_name_two",
                value: "contact_name_two",
                type: "text",
                labelFor: "Contact Name Two",
                label: "Contact Name Two",
                required: false,
                messagePosition: 'toast',
                className: "col-12 md:col-6",
            },
            {
                id: "contact_number_two",
                name: "contact_number_two",
                value: "contact_number_two",
                type: "text",
                labelFor: "Contact Number Two",
                label: "Contact Number Two",
                required: false,
                messagePosition: 'toast',
                className: "col-12 md:col-6",
            },
            {
                id: "address_one",
                name: "address_one",
                value: "address_one",
                type: "text",
                labelFor: "Address One",
                label: "Address One",
                required: true,
                messagePosition: 'toast',
                className: "col-12 md:col-6",
            },
            {
                id: "address_two",
                name: "address_two",
                value: "address_two",
                type: "text",
                labelFor: "Address Two",
                label: "Address Two",
                required: false,
                messagePosition: 'toast',
                className: "col-12 md:col-6",
            },
            {
                id: "website",
                name: "website",
                value: "website",
                type: "website",
                labelFor: "Website",
                label: "Website",
                required: false,
                messagePosition: 'toast',
                className: "col-12 md:col-6",
            },
            {
                id: "remark",
                name: "remark",
                value: "remark",
                type: "textarea",
                labelFor: "Remark",
                label: "Remark",
                required: false,
                messagePosition: 'toast',
                row: "1",
                className: "col-12 md:col-6",
            },
        ];

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    {
                        user.user_type === 'ADMIN' ? 
                        <>
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editSupplier(rowData)} />
                        <Toast ref={toast} />
                        <ConfirmPopup />
                        <Button 
                            onClick={(e) => {
                                DeleteModal(e, rowData.id);
                            }} 
                            icon="pi pi-trash" 
                            className="p-button-rounded p-button-warning mt-2"
                        />
                        </> : <></>
                    }
                </div>
            </>
        );
    }

    return (
        <>
            <Table
                //data
                tableHeaderName="Supplier Details"
                tableColumns={tableColumns}
                data={supplierList}
                loading={supplierListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
            <CreateModal 
                dialogVisible={showForm} 
                column={3} 
                onHide={hideModal} 
                inputData={inputData} 
                formik={formik} 
                dialogHeader={`${!updateData ? "Create" : "Update "} Supplier`} 
                modalWidth="1000px" 
                reset={resetForm} 
                btnLoading={supplierAddLoading || supplierUpdateLoading} 
                update={updateData} 
                disabled={duplicateNameExist}
                col1={8}
                col2={updateData ? 3 : 4}
                col3={6}
            />
        </>
    );
};

export default Supplier;
